<template>
  <Card>
    <LocalDataTable :ajax-link="ajaxLink" :columns="columns"></LocalDataTable>
  </Card>
</template>

<script>
import Card from "@/components/forms/Card";
import {mapActions} from "vuex";
import LocalDataTable from "@/components/LocalDataTable";
export default {
name: "RequestRegisterBrandList",
  components: {LocalDataTable, Card},
  data(){
  return{
    ajaxLink : 'admin/RequestBrand/List',
    columns : [
      {title : 'شماره'},
      {title : 'تاریخ درخواست'},{title: 'عنوان'},{title: 'درخواست دهنده'},
      {title: 'وضعیت'},{title: '<i class="far fa-cogs"></i>',sortable : false}
    ]
  }
  },
  mounted()
  {
    this.setPageTitle('درخواست های ثبت برند');
    this.setShowHead(true);
    this.setPageLoading(false);
  },
  methods:{
    ...mapActions('app',{
      setPageTitle:'setPageTitle',
      setPageLoading:'setPageLoading',
      setShowHead : 'setShowHead'
    }),
  }
}
</script>

<style scoped>

</style>